import { XYOffset } from 'src/app/types/xyoffset';
import { PixoPt, PixoSpatialCoord } from './../Pixospatial';
import { Geometry, GeometryObject } from '@turf/turf';
import { Feature, IFeatureContext } from './Feature';
import { PixoSpatial } from '../Pixospatial';
import { EventEmitter } from '@angular/core';
import { MapService } from 'src/app/services/map.service';
import { SnapLayerAPIService } from '../api-services/snap-layer-api.service';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { InterruptableTimer } from '../interruptabletimer';
import * as d3 from 'd3';
export class SnapSegs extends Feature {
  get type(): string {
    return 'snap-segs';
  }
  public map: ISLMap;
  private snapSelections: Array<string> = [];
  public groupMode: boolean = false;
  private timer = new InterruptableTimer(500);
  public segments: Array<any> = [];
  public snapLayerAPI: SnapLayerAPIService;
  protected lookup: any = {};
  private vis: boolean = true;

  public enteredChange = new EventEmitter<any>();

  public get geometryCount(): number {
    let length = 0;
    const segments = 'segments';
    if (this[segments] && this[segments].length) {
      length += this[segments].length;
    }
    length += this.points.length;
    return length;
  }
  public geometryLoad = new EventEmitter<void>();
  constructor(context: IFeatureContext, spatialContext?: PixoSpatial) {
    super(context, spatialContext);
    this.snapLayerAPI = MapService.Get().snapLayerService;
    this.snapLayerAPI = MapService.Get().snapLayerService;
    this.snapLayerAPI.AddLoadListener(this.id, (value: SnapLayerAPIService) => {
      if (!this.map) {
        this.map = MapService.Get();
        this.map.ui.on('render', () => {
          this.ContextChanged();
        });
        this.map.ui.on('idle', () => {
          this.ContextChanged();
          return;
          this.timer.Start(() => {
            this.Redraw();
          })
        })
      }
      this.geometryLoad.emit();
      this.Redraw();
    });
  }

  MakeVertex(points: Array<any>, ptGroup: any, ptInfo, xProp: string = 'x', yProp: string = 'y', zProp: string = 'z'): any {
    return;
  }
  AddSnapSegment(segInfo: any): void {
    const [from, to] = segInfo;
    const fromCoord = this.spatialContext.PixoSpatialCoord(this.spatialContext.SpatialCoord(from));
    const toCoord = this.spatialContext.PixoSpatialCoord(this.spatialContext.SpatialCoord(to));

    this.MakeSnapSegment(this.segments, this.context.snapSeg, fromCoord, toCoord);

  }
  MakeSnapSegment(segments, segmentGroup, fromPt: PixoSpatialCoord, toPt: PixoSpatialCoord): any {

    const seg: any = {};
    seg.type = 'snap-segment';
    seg.featureId = this.id;
    seg.id = this.GenerateId();
    seg.from = fromPt;
    // seg.from.segments.push(seg);
    seg.to = toPt;
    //seg.to.segments.push(seg);
    seg.ui = segmentGroup.append('line');


    seg.updateUI = () => {
      const length = this.spatialContext?.SpatialDistance(seg.from.spatial, seg.to.spatial, 'meters-m');
      const info: any = {
        x1: seg.from.pixo.x,
        y1: seg.from.pixo.y,
        x2: seg.to.pixo.x,
        y2: seg.to.pixo.y,
        class: 'snap-segment',
        'data-guid': seg.id
      };

      for (const key in info) {
        if (info.hasOwnProperty(key)) {
          seg.ui.attr(key, info[key]);
        }
      }
    };
    seg.updateUI();

    seg.ui.on('click', () => {
      const clickPt = this.spatialContext.PixoSpatialCoord(this.spatialContext.PixoPt({ x: d3.event.offsetX, y: d3.event.offsetY }));
      seg.lastClick = this.spatialContext.GetNearestCoord(seg.from, seg.to, clickPt);

      if (!this.IsSelected(seg.id)) {
        this.Select(seg.id);
      }
      if (d3.event.cancelable === true) {
        d3.event.preventDefault();
      }
    });
    this.lookup[seg.id] = seg;
    seg.ui.on('mouseenter', (event) => {
      if ((d3.event.buttons & 1) !== 0) {
        const clickPt = this.spatialContext.PixoSpatialCoord(this.spatialContext.PixoPt({ x: d3.event.offsetX, y: d3.event.offsetY }));
        seg.lastClick = this.spatialContext.GetNearestCoord(seg.from, seg.to, clickPt);
        this.enteredChange.emit(seg);
      }
    })
    seg.removed = false;
    seg.remove = (uiOnly: boolean = false) => {
      seg.removed = true;
      seg.ui.on('click', null);
      seg.ui.remove();
      if (!uiOnly) {
        const segi = segments.indexOf(seg);
        segments.splice(segi, 1);
        delete this.lookup[seg.id];
      }

      return seg;
    };
    this.segments.push(seg);
    return seg;
  }
  HasSnapSeg(id: string) {
    return !!this.lookup[id]
  }
  private _active: boolean = true;
  SetActive(isActive: boolean) {
    this._active = isActive;
    this.context.snapPt.attr('data-active', isActive ? 'true' : 'false');
  }
  RemoveSelected() {
    if (this.snapSelections.length === 0) {
      return;
    }
    for (const selection of this.snapSelections) {
      if (!this.HasSnapSeg(selection)) continue;
      const seg = this.lookup[selection];
      if (seg.type !== 'snap-segment') return;
      const index = this.segments.indexOf(seg);
      if (index >= 0) {
        this.segments.splice(index, 1);
      }
      seg.remove();
    }
    this.snapSelections = [];
  }

  ContextChanged() {
    if (this.spatialContext === null) { return; }
    for (const seg of this.segments) {
      seg.from.UpdateSpatial(seg.from.spatial.lng, seg.from.spatial.lat)
      seg.to.UpdateSpatial(seg.to.spatial.lng, seg.to.spatial.lat);
      seg.updateUI();
    }
    this.UpdateContextHandler();
    // this.context.updateHandler(this);
  }
  public GetSelectedInfo(): Array<any> {
    if (!this.snapSelections) {
      return undefined;
    }
    const segs: Array<any> = [];
    for (const selection of this.snapSelections) {
      segs.push(this.lookup[selection]);
    }
    return segs;
  }
  public GetGeometry(): Array<any> {
    const geometry: Array<any> = [];
    const segments = 'segments';
    let ctr = -1;
    for (const seg of this.segments) {
      geometry.push(seg);
    }
    return geometry;
  }
  public IsSelected(geomId: string): boolean {
    return this.snapSelections.indexOf(geomId) > -1;
  }
  public Remove(): void {
    this.Clear();
    this.context.snapSeg.remove();
  }
  Clear() {
    this.RemoveSegments();
  }
  RemoveSegments() {
    for (const seg of this.segments) {
      seg.remove(true);
    }
    this.segments = [];
    this.lookup = [];
    this.snapSelections = [];
  }
  ToGeoJSONGeom(): GeometryObject | false {
    return false; // override me;
  }
  FromGeoJSONGeom(_1geom: Geometry): void {
    return;
  }
  AddVertex(ptInfo: any, xProp?: string, yProp?: string): void {
    // do nothing; override me
  }
  Deselect(targetId?: string, batch: boolean = false) {
    if (!targetId) {
      for (let i = this.snapSelections.length - 1; i >= 0; i--) {
        const selection = this.snapSelections[i];
        this.Deselect(selection, true);
      }
      this.selectionChange.emit({ source: this, selections: targetId });

      return;
    }
    const selection = this.lookup[targetId];
    if (!!selection) {
      selection.ui.attr('data-selected', 'false');
      const offset = this.snapSelections.indexOf(targetId);
      this.snapSelections.splice(offset, 1);
    }
    if (!batch) this.selectionChange.emit({ source: this, selections: targetId });


  }
  Select(targetId: string): void {
    if (this.groupMode === false) {
      for (const selection of this.snapSelections) {
        this.Deselect(selection);
      }
      this.snapSelections.splice(0, this.snapSelections.length);
    }
    if (this._active === false) return;
    if (!this.HasSnapSeg(targetId)) return;

    this.lookup[targetId].ui.attr('data-selected', 'true');

    if (this.groupMode === true) {
      this.snapSelections.push(targetId);
      this.selectionChange.emit({ source: this, selections: targetId });
    } else {
      this.snapSelections[0] = targetId;
      this.selectionChange.emit({ source: this, selectedId: targetId });
    }

  }
  Redraw() {
    this.Clear();
    this.snapSelections = [];
    const snapSegs = this.snapLayerAPI.GetSnapSegments();
    for (const snapSeg of snapSegs) {
      this.AddSnapSegment(snapSeg);
    }
  }
  ToggleVis(isOn?: boolean) {
    if (isOn === undefined) isOn = !this.vis;
    this.vis = isOn;
    this.UpdateVis();
  }
  SetOpacity(val: number) {
    this.context.snapSeg.node().style.setProperty('opacity', val)

  }
  UpdateVis() {
    this.context.snapSeg.attr('data-hidden', (this.vis ? 'false' : 'true'));
  }
}
